import { TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import clsx from 'clsx'
import { FC } from 'react'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import useStyles from './_styles'
import { CommonDatePickerProps } from './_props'

const CommonDatePicker: FC<CommonDatePickerProps> = ({ dataCy, className, ...props }) => {
    const classes = useStyles()

    const renderCombined = () => (
        <div className={clsx(classes.CommonDatePicker)}>
            <TextField
                label="date et heure"
                {...props}
                className={clsx(classes.CommonDatePickerField, className)}
                id="datetime-local"
                type="datetime-local"
                sx={{ width: 250 }}
                InputLabelProps={{
                    shrink: true,
                }}
                data-cy={dataCy}
            />
        </div>
    )

    return <LocalizationProvider dateAdapter={AdapterMoment}>{renderCombined()}</LocalizationProvider>
}

export default CommonDatePicker
